import React from 'react'
import { Typography } from '@material-tailwind/react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import SmartLink from '@components/SmartLink/SmartLink'
import Logo from '@icons/logo'
import SubscribeForm from '@components/SubscribeForm'
import './Footer.less'

export function Footer() {
  const [datas, setDatas] = React.useState({})

  const {
    data: { nodes },
  } = useStaticQuery(graphql`
    {
      data: allContentfulJson(
        filter: {
          name: { in: ["footer", "social", "friendlinks", "policylinks"] }
          node_locale: { eq: "en-US" }
        }
      ) {
        nodes {
          name
          data {
            internal {
              content
            }
          }
        }
      }
    }
  `)

  React.useEffect(() => {
    if (nodes && nodes.length > 0) {
      setDatas(regroupData(nodes))
    }
  }, [nodes])
  const regroupData = (list) => {
    const result = {}
    list.forEach((item) => {
      const { name, data } = item
      if (!result[name]) {
        result[name] = sortByOrderRecursive(
          data.map((i) => {
            return JSON.parse(i.internal.content)
          }),
        )
      }
    })
    return result
  }
  const sortByOrderRecursive = (items) => {
    if (!Array.isArray(items)) return []

    return items
      .map((item) => ({
        ...item,
        children: item.children ? sortByOrderRecursive(item.children) : [],
      }))
      .sort((a, b) => a.order - b.order)
  }
  const { footer, social, friendlinks, policylinks } = datas
  return (
    <footer className="footer-container w-full px-0 pt-12 text-white mt-20 text-sm text-[var(--grey)]">
      {/* 订阅表单部分 */}
      <div className="responsive-frame">
        <div className="row1 flex justify-between flex-wrap gap-5">
          <div className="left-wrapper">
            <div className="logo mb-5">
              <Logo className="w-[107px] mb-2" />
              <Typography className="block text-left font-normal text-xs">
                Power Beyond Charging
              </Typography>
            </div>
            <SubscribeForm
              placeholder="Email"
              buttonText="Subscribe"
              className="footer-subscribe"
            />
          </div>
          {/* <nav
            className={`links xl:row-span-2 grid grid-cols-5 md:!grid-cols-1 justify-center mx-[2rem] l:mx-[0] whitespace-nowrap`}
            style={{
              gridTemplateColumns: `repeat(${(footer || []).length}, minmax(0px, 1fr))`,
            }}
          > */}
          {(footer || []).map((item, index) => {
            return (
              <div className="link-item" key={`footer-${index}`}>
                <Typography
                  key={index}
                  variant="h2"
                  className="block text-center text-base leading-6 font-bold text-white"
                >
                  {item.title}
                </Typography>
                {(item.children || []).map((child, index) => {
                  const { title, link } = child
                  return (
                    <Typography
                      key={index}
                      className="block text-center font-normal text-sm mt-3 leading-6 "
                    >
                      <SmartLink className="hover:text-white" to={link}>
                        {title}
                      </SmartLink>
                    </Typography>
                  )
                })}
              </div>
            )
          })}
          {/* </nav> */}
          <div className="extention xl:row-span-1 flex-shrink-0">
            <nav className="friendlinks">
              {(friendlinks || []).map((item, index) => {
                const { label, link, title } = item
                return (
                  <div
                    className="friendlink-item flex flex-wrap align-middle"
                    key={`friendlink-${index}`}
                  >
                    <Typography className="text-sm">{label} </Typography>
                    <Typography key={index} className="text-center text-sm">
                      <SmartLink className="hover:text-white" to={link}>
                        {title}
                      </SmartLink>
                    </Typography>
                  </div>
                )
              })}
            </nav>
            <nav className="social flex mt-14">
              {(social || []).map((item, index) => {
                const { icon, link, title } = item
                return (
                  <div
                    className="social-item flex items-center"
                    key={`social-${index}`}
                  >
                    <SmartLink
                      className="hover:text-white flex-1 mx-1"
                      to={link}
                    >
                      <img src={icon} className="min-w-[10px]" alt={title} />
                    </SmartLink>
                  </div>
                )
              })}
            </nav>
          </div>
        </div>
        <div className="text-center items-center w-full mt-14 pb-8">
          <small className="text-sm">
            © 2025 <Link className="cursor-pointer">Docky Lab.</Link> All
            Rights Reserved.
            {(policylinks || []).map((item, index) => {
              const { label, link } = item
              return (
                <>
                  <span className="mx-2">|</span>
                  <SmartLink
                    key={`policylink-${index}`}
                    className="underline"
                    to={link}
                  >
                    {label}
                  </SmartLink>
                </>
              )
            })}
          </small>
        </div>
      </div>
    </footer>
  )
}
